module.exports = __webpack_public_path__ + "img/type-6.4ffb3483.png";